import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { FilterSideBarLoadingSkeleton } from "@faire/retailer-visitor-shared/components/Filters/FilterSideBarLoadingSkeleton";
import { GhostBlock } from "@faire/retailer-visitor-shared/components/GhostLoading/GhostBlock";
import { FilmstripBrandListSkeleton } from "@faire/retailer-visitor-shared/views/suppliers/SuppliersPageLoadingSkeleton/FilmstripBrandListSkeleton";
import { SuppliersPageHeaderLoadingSkeleton } from "@faire/retailer-visitor-shared/views/suppliers/SuppliersPageLoadingSkeleton/SuppliersPageHeaderLoadingSkeleton";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import React from "react";
import styled from "styled-components";
export var SuppliersPageLoadingSkeleton = function(param) {
    var _param_hideHeader = param.hideHeader, hideHeader = _param_hideHeader === void 0 ? false : _param_hideHeader;
    return /*#__PURE__*/ _jsxs("div", {
        "data-test-id": "suppliers-page-loading-skeleton",
        style: {
            overflow: "hidden"
        },
        children: [
            !hideHeader ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(HeaderBackground, {
                        children: /*#__PURE__*/ _jsx(HeaderColumn, {
                            children: /*#__PURE__*/ _jsx(SuppliersPageHeaderLoadingSkeleton, {})
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "9x"
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsxs(MainContentColumn, {
                children: [
                    /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                        tabletAndAbove: /*#__PURE__*/ _jsx(GhostBlock, {
                            $width: "400px",
                            $height: "38px"
                        }),
                        mobile: /*#__PURE__*/ _jsx(GhostBlock, {
                            $width: "300px",
                            $height: "38px"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "3x"
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        gap: "2x",
                        direction: {
                            mobileAndAbove: "column",
                            desktopAndAbove: "row"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                                tabletAndBelow: /*#__PURE__*/ _jsx(GhostBlock, {
                                    $height: "40px",
                                    $borderRadius: "20px",
                                    $width: "120px"
                                }),
                                desktopAndAbove: /*#__PURE__*/ _jsx(FilterSideBarLoadingSkeleton, {
                                    hideSideNav: true,
                                    filterCount: 6
                                })
                            }),
                            /*#__PURE__*/ _jsx(FilmstripBrandListSkeleton, {})
                        ]
                    })
                ]
            })
        ]
    });
};
var HeaderBackground = styled.div.withConfig({
    componentId: "sc-eafb9b1c-0"
})([
    "background-color:",
    ";"
], Decorative.tint.neutral);
var HeaderColumn = styled(Column).withConfig({
    componentId: "sc-eafb9b1c-1"
})([
    "width:100%;max-width:1280px;margin:0 auto;",
    "{padding:32px 16px 40px 16px;}",
    "{padding:32px 40px 40px 40px;}",
    "{padding:32px 80px 40px 80px;}"
], responsiveMediaQueries.mobile, responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove);
var MainContentColumn = styled(Column).withConfig({
    componentId: "sc-eafb9b1c-2"
})([
    "width:100%;max-width:1280px;margin:0 auto;",
    "{padding:0px 16px 40px 16px;}",
    "{padding:0px 40px 40px 40px;}",
    "{padding:0px 80px 40px 80px;}"
], responsiveMediaQueries.mobile, responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove);
